export default __webpack_public_path__ + "static/video-sound-beep-29423ee9d5ffc4288adf89726250fe39.mp3";